var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameAchivement = function SvgIconStorygameAchivement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.789V4c5 0 9-3 9-3s4 3 9 3v8.789c0 .79-.226 1.57-.701 2.2C14.939 20.112 10.5 21 10.5 21s-4.44-.888-8.299-6.01c-.475-.632-.701-1.411-.701-2.201Z",
    stroke: "#fff",
    strokeOpacity: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.155 7.24a.367.367 0 0 1 .69 0l.643 1.615 1.668.14c.331.027.465.459.213.685l-1.271 1.137.388 1.701c.077.338-.274.604-.558.424L10.5 12.03l-1.428.912c-.284.18-.635-.086-.558-.424l.388-1.7L7.631 9.68c-.252-.226-.118-.658.213-.685l1.668-.14.643-1.615Z",
    fill: "#fff"
  })));
};
export default SvgIconStorygameAchivement;